"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MangopayPersonType = void 0;
var MangopayPersonType;
(function (MangopayPersonType) {
    MangopayPersonType["Natural"] = "NATURAL";
    MangopayPersonType["Legal"] = "LEGAL";
})(MangopayPersonType || (exports.MangopayPersonType = MangopayPersonType = {}));
//# sourceMappingURL=MangopayPersonType.js.map